const initState = {
    ao: 1,
    risks: [],
    error: null,
    isOverlayOpen: false,
    id: null,
    risk: null,
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    go_to_risk_dashboard: null,
    go_to_bowtie: null,
    bowtie: null,
    departments: [],
    sortBy: {},
    sorted_triggered: false,
    preliminary_risk: null,
    changed_page_size: false,
    control_details: null,
    control_comments: null,
    action_details: null,
    action_comments: null,
    risks_report: [],
    all_risks_report: [],
    risk_controls: [],
    all_risk_controls: [],
    compliance_controls: [],
    risk_actions: [],
    risk_incidents: [],
    levels: [],
    actions_stats: [],
    complianceRisks: [],
    department_incidents: [],
};

const riskReducer = (state = initState, action) => {




    switch (action.type) {

        case "LEVELS":
            return {
                ...state,
                levels: action.levels,
            };


        case "INCIDENTS_REPORT":
            return {
                ...state,
                risk_incidents: action.risk_incidents,
            };

        case "ACTIONS_REPORT":
            return {
                ...state,
                risk_actions: action.risk_actions,
            };

        case "CONTROLS_REPORT":
            //console.log("CONTROL REPORT ACTOIN", action);
            return {
                ...state,
                risk_controls: action.risk_controls,
            };
        case "CONTROLS_SEARCH":
            //console.log("CONTROL REPORT ACTOIN", action);
            return {
                ...state,
                all_risk_controls: action.risk_controls,
            };

        case "COMPLIANCE_CONTROLS_REPORT":
            return {
                ...state,
                compliance_controls: action.compliance_controls,
            };

        case "RISKS_REPORT":
            return {
                ...state,
                risks_report: action.risks_report,
            };
        case "ALL_RISKS_REPORT":
            return {
                ...state,
                all_risks_report: action.risks_report,
            };

        case "ACTION_DETAILS":
            return {
                ...state,
                action_details: action.action_details,
                action_comments: action.comments,
            };
        case "UPDATE_ACTION_PROGRESS":
            return {
                ...state,
                actions: state.actions.map((a) =>
                    a.action_id === action.payload.action_id ? { ...a, progress: action.payload.progress } : a
                ),
            };

        case "CONTROL_DETAILS":
            //console.log("CONTROL_DETAILS action received:", action);
            //console.log(" control_details.start_date before setting state:", action.control_details.start_date);
            return {
                ...state,
                control_details: {
                    ...action.control_details, // Now includes attachments from the action

                },
                control_comments: action.comments ?? state.control_comments, // Ensure comments are updated correctly
            };

        case "ADD_ATTACHMENT":
            return {
                ...state,
                control_details: {
                    ...state.control_details,
                    attachments: [...(state.control_details.attachments || []), action.attachment],
                },
            };

        case "DELETE_ATTACHMENT":
            return {
                ...state,
                control_details: {
                    ...state.control_details,
                    attachments: state.control_details.attachments.filter(
                        (attachment) => attachment.attachment_id !== action.attachment_id
                    ),
                },
            };

        case "RESETALLTABLEDEFINITIONS":
            return {
                ...state,
                currentPage: 1,
                pageSize: 10,

            };

        case "RESET_PRELIMINARY_RISK":
            return {
                ...state,
                preliminary_risk: null,
            };

        case "DEPARTMENTS":
            return {
                ...state,
                departments: action.departments,
            };

        case "RESET_GOTO_RISK_DASHBOARD":
            return {
                ...state,
                go_to_risk_dashboard: null,
            };

        case "GOTO_RISK_DASHBOARD":
            return {
                ...state,
                go_to_risk_dashboard: action.risk_id,
            };

        case "RESET_GOTO_BOWTIE":
            return {
                ...state,
                go_to_bowtie: null,
                bowtie: null
            };

        case "GOTO_BOWTIE":
            return {
                ...state,
                go_to_bowtie: action.risk_id,
            };

        case "BOWTIE":
            return {
                ...state,
                bowtie: action.bowtie,
            };

        case "BOWTIE_CLOSE":
            return {
                ...state,
                go_to_bowtie: null,
                bowtie: null
            };

        case "RESET_SORTED_TRIGGERED":
            return {
                ...state,
                sorted_triggered: false,
            };

        case "RESET_CHANGED_PAGE_SIZE":
            return {
                ...state,
                changed_page_size: false,
            };

        case "SET_SORT_BY":
            return {
                ...state,
                sortBy: action.sortBy,
                sorted_triggered: true,
            };

        case "SET_CURRENT_PAGE":
            return {
                ...state,
                currentPage: action.currentPage,
                sorted_triggered: true,
            };


        case "CREATE_PRELIMINARY_RISK":
            return {
                ...state,
                preliminary_risk: action.preliminary_risk,
            };

        case "SET_PAGE_SIZE":
            return {
                ...state,
                pageSize: action.pageSize,
                //sorted_triggered: true,
                changed_page_size: true,
            };

        case "RISK":
            console.log('Risk reducer - Received risk data:', action.risk);
            return {
                ...state,
                risk: action.risk,
            };

        case "OPEN_OVERLAY":
            return {
                ...state,
                isOverlayOpen: true,
                id: action.id
            };

        case "CLOSE_OVERLAY":
            console.log("Overley Closed")
            return {
                ...state,
                isOverlayOpen: false,
                id: null,
                risk: null,
            };

        case "RESET_ERROR":
            return {
                ...state,
                //risks: [],
                error: null,
            };

        case "RESET_NEWLYCREATED_RISK_ID":
            return {
                ...state,
                newlycreatedRiskId: null,
            };



        case "RISKS":
            return {
                ...state,
                risks: action.risks,
                totalPages: action.totalPages,
                risk: null,
                newlycreatedRiskId: action.newlycreatedRiskId ? action.newlycreatedRiskId : null,
            };

        case "COMPLIANCE_RISKS":
            //console.log(action);
            return {
                ...state,
                complianceRisks: action.complianceRisks,
                complianceTotalPages: action.totalPages,
                risk: null,
                newlyCreatedComplianceRiskId: action.newlyCreatedComplianceRiskId ? action.newlyCreatedComplianceRiskId : null,
            };


        case "ERROR_CREATING_RISK":
            return {
                ...state,
                error: action.error,
            };

        case "DEPARTMENT_INCIDENTS":
            return {
                ...state,
                department_incidents: action.department_incidents,
            };

        case "ACTIONS_STATS":
            return {
                ...state,
                actions_stats: action.risk_actions



            }

        default:
            return state;
    }
};

export default riskReducer;
